import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { APP_CONFIG, ConfigService } from '@services/config.service';
import { UserService } from '@services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@services/notification.service';
import { Direction } from '@angular/cdk/bidi';
import { AuthenticationService } from '@services/authentication.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'dcp-bo';
  hideMenu = true;
  envParam = { color: '', backgroundColor: '', show: '', name: '' };
  direction = 'ltr' as Direction;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private configService: ConfigService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private titleService: Title,
    private router: Router,
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(this.configService.getCurrentLanguage()); // load first lang
    this.configService.currentDirection.subscribe((direction) => (this.direction = direction as Direction));
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      if (event.url === '/login' || event.url === '/lost-password') {
        this.hideMenu = true;
      } else {
        if (!this.userService.userSubject.value || this.authenticationService.isTokenExpired(this.authenticationService.getToken())) {
          this.userService.getMe().subscribe(
            (user) => {
              if (user && !this.authenticationService.isTokenExpired(this.authenticationService.getToken())) {
                this.hideMenu = false;
              } else {
                this.notificationService.sendError('Can\'t get current user');
                this.router.navigate(['/login']);
              }
            },
            (error) => {
              if (this.authenticationService.isTokenExpired(this.authenticationService.getToken())) {
                this.router.navigate(['/login']);
              }
            },
          );
        } else {
          this.hideMenu = false;
        }
      }
    });
  }

  ngOnInit(): void {
    this.envParam = APP_CONFIG.environmentParams;
    this.titleService.setTitle(APP_CONFIG.env + '-' + this.title);
  }
}
